import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import classNames from 'classnames';
import some from 'lodash/some'
import { Link } from 'react-router-dom'
 
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';

import { forgotPassword } from '@actions/auth';

import { rexgexEmail } from '@utils/general'

import './style.scss'

class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: false,
      btnSubmitLoading: false,
      email: '',
      errors: [],
    };
  }

  onChange = ({ target }) => {
    this.setState({ [target.name]: target.value }, this.validateFieldsOnchange(target.name, target.value));
  };

  validateFieldsOnchange = (name, value) => {
    const { errors } = this.state;
    if (errors[name] && value) {
      delete errors[name];
      this.setState({ errors });
    }
  };

  validateFields = async () => {
    const { t } = this.props;
    const {email, password } = this.state;
    let errors = {};
    if (!email) errors = { ...errors, 'email': `${t('Correo electrónico')} ${t('es requerido')}`  }
    if (email && !rexgexEmail.test(email)) errors = { ...errors, 'email': `${t('Correo electrónico')} ${t('es invalido')}`  }
    this.setState({ errors });
    return errors;
  };

  onSubmit = async (e) => {
    e.preventDefault();
    this.setState({btnSubmitLoading: true})
    const { history, t, forgotPassword } = this.props
    const { email } = this.state
    const validate = await this.validateFields()
    if (some(validate, {})) return this.setState({btnSubmitLoading: false})

    const response = await forgotPassword({ email })
    console.log('response', response)
    if (!response.status) {
      history.push({pathname: "/token", state: { email }})
    }
    return this.setState({ btnSubmitLoading: false });
  };

  render() {
    const { t, history } = this.props;
    const { email, btnSubmitLoading, errors } = this.state;

    const isFormFieldValid = (name) => !!errors[name];
    const getFormErrorMessage = (name) =>
      isFormFieldValid(name) && (
        <small className="p-error">{errors[name]}</small>
      );

    return (
      <section className="loginCont is-full-height p-d-flex p-jc-center p-ai-center">
        <div className="conteiner">
          <div className="p-grid">
            <div className="p-col-12 card p-p-6">
              <div className="p-grid containerForm">
                <div className="p-col-3">
                  <Link to="/" className="logo">
                    <img src="/assets/img/logo-compliance.svg" width="117" height="100" alt="Programa integridad y cumplimiento Compromiso de todos" />
                  </Link>
                </div>
                <form onSubmit={this.onSubmit} className="p-col-6 p-fluid p-pt-5">
                  <h2 className="p-mb-6 p-text-center p-mt-5"> {t('Recuperación de contraseña')} </h2>
                  <p className="p-mb-6 p-text-center"> {t('Te enviaremos un email con instrucciones sobre cómo reestablecer tu contraseña. Por favor ingresa el correo electrónico con el que inicias sesión.')} </p>
                  <div className="p-field p-mb-5">
                    <label
                      htmlFor="email"
                    >
                      {t('Correo electrónico')}
                    </label>
                    <InputText
                      name="email"
                      type="text"
                      value={email}
                      onChange={this.onChange}
                      autoFocus
                      autoComplete='off'
                      className={classNames('p-mb-2',{
                        'p-invalid': isFormFieldValid(`email`),
                      })}
                    />
                    {getFormErrorMessage('email')}
                  </div>
                  <Button type="submit" label={t('Enviar')} className="p-button p-mt-3" loading={btnSubmitLoading} loadingoptions={{ position: 'right' }}/>
                  <Button
                    className=" p-button-text p-button-primary p-mt-5"
                    label={t("Cancelar")}
                    type="button"
                    loading={btnSubmitLoading}
                    onClick={() => history.push("/")}
                  />
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

const mapDispatchToProps = {
  forgotPassword
};

export default compose(
  withTranslation(),
  connect(null, mapDispatchToProps)
)(ForgotPassword);
